import { DeleteCmd } from "./delete/delete"
import { CreateCroppingCmd, UpdateCroppingsCmd, UpdateFieldsCmd } from "./edit/editCmd"
import { GrassMarginCmd } from "./grassMargin/grassMarginCmd"
import { InfieldFeaturesCmd } from "./infieldFeatures/infieldFeaturesCmd"
import { MergeCmd } from "./merge/mergeCmd"
import { FieldViewModel, IOmniaCommand, str } from "./omnia"
import { SplitCmd } from "./split/splitCmd"
import { commands } from "./strings"
import { IFieldsModuleContext } from "./types"

/// <reference path="strings.ts" />

const cmd = commands

type Context = Omit<IFieldsModuleContext, "map" | "mapView">

export function getCroppingCommands(context: Context, includesTimelineCommands: boolean): IOmniaCommand[] {

    const { svc, readOnly } = context

    const update = new UpdateCroppingsCmd(context, cmd.editCropping)

    const zoom: IOmniaCommand = {
        text: str.Zoom,
        icon: "search",
        execute: (field: FieldViewModel) => svc.locateItems([field]),
        canExecute: (field: FieldViewModel) => field && field.hasBoundary(),
        foreground: true,
    };

    if (readOnly) {
        return [update, zoom]
    }

    let commands: IOmniaCommand[] = []

    commands.push(new CreateCroppingCmd(context, cmd.newCropping))

    commands = commands.concat([
        update,
        new SplitCmd(context),
        new MergeCmd(context)
    ])

    if (!includesTimelineCommands) {
        commands.push(new GrassMarginCmd(context))
        commands.push(zoom);
    }

    commands.push(new DeleteCmd(context))

    return commands
}

export function getCroppingCommandsForDetailBox(context: Context): IOmniaCommand[] {
    // Get all of the usual commands, except "zoom"
    return getCroppingCommands(context, false).filter(x => x.text !== str.Zoom);
}

export function getFieldCommands(context: Context, includesTimelineCommands: boolean = false, editInBackground?: boolean): IOmniaCommand[] {

    const { svc, readOnly } = context

    const update = new UpdateFieldsCmd(context, cmd.editField, !editInBackground)

    const zoom: IOmniaCommand = {
        text: str.Zoom,
        icon: "search",
        execute: (field: FieldViewModel) => svc.locateItems([field]),
        canExecute: (field: FieldViewModel) => field && field.hasBoundary(),
        foreground: true,
    };

    if (readOnly) {
        return [update, zoom]
    }

    const commands: IOmniaCommand[] = [
        new CreateCroppingCmd(context),
        update
    ]

    if (!includesTimelineCommands) {
        commands.push(new InfieldFeaturesCmd(context))
        commands.push(zoom)
    }

    commands.push(new DeleteCmd(context))

    return commands

}

export function getFieldGroupCommands(context: Context): IOmniaCommand[] {
    const { svc } = context;

    const zoom: IOmniaCommand = {
        text: str.Zoom,
        icon: "search",
        execute: (fieldGroup: string) => {
            // Find all fields for the specified field group.
            const fields = (svc.getFields(false) || []).filter((x) => x.visible && x.fieldGroup === fieldGroup);
            // Find those fields on the map.
            svc.locateItems(fields);
        },
        canExecute: () => true,
        foreground: true,
    };

    return [zoom];
}
